var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGeneralAssistant(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2656 21.5996V16.3822C10.2656 15.4217 11.0442 14.6431 12.0048 14.6431H18.9613C19.9218 14.6431 20.7004 15.4217 20.7004 16.3822V21.5996",
    stroke: "#07094F",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78516 5.94752C6.78516 4.02652 8.34242 2.46926 10.2634 2.46926C12.1844 2.46926 13.7417 4.02652 13.7417 5.94752C13.7417 7.86852 12.1844 9.42578 10.2634 9.42578C8.34242 9.42578 6.78516 7.86852 6.78516 5.94752Z",
    stroke: "#07094F",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2651 21.5996H5.04772C4.0872 21.5996 3.30859 20.821 3.30859 19.8605V14.6431C3.30859 12.7221 4.86585 11.1648 6.78685 11.1648H13.7434C15.6644 11.1648 17.2216 12.7221 17.2216 14.6431",
    stroke: "#07094F",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04688 22.4688C5.52698 22.4688 5.91676 22.0797 5.91699 21.5996C5.91699 21.1194 5.52712 20.7305 5.04688 20.7305H0.873047C0.392995 20.7307 0.00390625 21.1195 0.00390625 21.5996C0.0041358 22.0795 0.393136 22.4685 0.873047 22.4688H5.04688ZM23.1338 22.4688C23.6139 22.4688 24.0037 22.0797 24.0039 21.5996C24.0039 21.1194 23.614 20.7305 23.1338 20.7305H10.2646C9.78446 20.7305 9.39551 21.1194 9.39551 21.5996C9.39574 22.0796 9.7846 22.4687 10.2646 22.4688H23.1338Z",
    fill: "#07094F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3524 18.1207C16.3524 18.6009 15.9631 18.9902 15.4828 18.9902C15.0026 18.9902 14.6133 18.6009 14.6133 18.1207C14.6133 17.6404 15.0026 17.2511 15.4828 17.2511C15.9631 17.2511 16.3524 17.6404 16.3524 18.1207Z",
    fill: "#07094F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneralAssistant);
export default __webpack_public_path__ + "static/media/icon-general-assistant.4cff30c7cd4eec24ce5ab69857d7aa71.svg";
export { ForwardRef as ReactComponent };